module.exports = __webpack_public_path__ + "img/92095.bef2903d.svg";